<template>
  <portal to="modal-target">
    <bs-modal
      id="delete"
      show-header
      dialog-centered
      @close="closeDeleteModalHandler"
    >
      <template slot="modal-title">
        <h5 class="modal-title">お届け先削除依頼</h5>
      </template>
      <p class="text-center">
        削除するお届け先を確認後　「削除依頼送信」を押下してください。
      </p>
      <table class="table table-bordered tbl_edit01" v-if="deliveryData">
        <tbody>
          <tr>
            <th class="bg-tbl-light">お届け先名</th>
            <td>{{ deliveryData.dlcompany_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">お届け先支店名</th>
            <td>{{ deliveryData.dlcompanysub_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">お届け先カナ</th>
            <td>{{ deliveryData.dlcompanykana_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">郵便番号</th>
            <td>{{ deliveryData.dlpost_cd }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所</th>
            <td>{{ deliveryData.dladdress_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">TEL</th>
            <td>{{ deliveryData.dltel_no }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">FAX</th>
            <td>{{ deliveryData.dlfax_no }}</td>
          </tr>
        </tbody>
      </table>
      <div class="alert alert-danger mt-3" v-if="delete_error.message">
        {{ delete_error.message }}
      </div>
      <template v-if="isEditable">
        <div class="btn_edit mt20">
          <button class="btn btn-secondary" @click="closeDeleteModalHandler">
            閉じる
          </button>
          <button class="btn btn-order02" @click="delDeliveryInfoHandler">
            削除依頼送信
          </button>
        </div>
      </template>
    </bs-modal>
  </portal>
</template>

<script>
export default {
  props: {
    deliveryData: { type: Object, required: true }
  },
  data() {
    return {
      // Delete Info
      delete_error: {}
    };
  },
  computed: {
    isEditable() {
      return (
        this.deliveryData.modify_fg != 1 &&
        this.deliveryData.modify_fg != 9 &&
        this.deliveryData.new_fg != 1
      );
    }
  },
  watch: {
    deliveryData: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init() {
      if (this.deliveryData.modify_fg == 1) {
        this.delete_error = {
          message: "指定されたお届け先は既に修正依頼されています。"
        };
      } else if (this.deliveryData.modify_fg == 9) {
        this.delete_error = {
          message: "指定されたお届け先は既に削除依頼されています。"
        };
      } else if (this.deliveryData.new_fg == 1) {
        this.delete_error = {
          message: "指定されたお届け先は新規登録依頼中です。"
        };
      } else {
        this.delete_error = {};
      }

      this.$bootstrap.showModal("delete");
    },

    async delDeliveryInfoHandler() {
      if (!this.deliveryData) {
        return;
      }
      this.delete_error = {};

      const response = await this.postAsteria(
        "CommonAPI",
        "delDeliveryInfo_req",
        {
          delivery_cd: this.deliveryData.delivery_cd
        }
      );

      if (response.responseData.return != 0) {
        // if (response.responseData.return != 9) {
        //   window.alert("お届け先削除依頼の送信に失敗しました");
        // }
        this.delete_error = response.responseData;
        return;
      }

      window.alert(
        "お届け先依頼送信が完了しました。\n\n※画面のお届け先は翌日以降に反映されます。\nしばらくお待ちください。"
      );

      this.$emit(
        "deleted",
        this.getAsteriaArray(response.responseData, "deliveryData")
      );
      this.closeDeleteModalHandler();
    },

    closeDeleteModalHandler() {
      this.$bootstrap.hideModal("delete");
      this.$emit("close");
    }
  }
};
</script>
